import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import BoostScaleIcon from '@assets/img/icons/boost-scale.svg?react';
import { useModal } from '@context/ModalContext';

import { StringXSmall } from '../Typography/Typography';

interface OpenPlantsBoostProps {
  kind: 'resource' | 'material' | 'goods';
}

const OpenPlantsBoost: FC<OpenPlantsBoostProps> = ({ kind }) => {
  const {
    setIsQuarryBoostModalOpen,
    setIsFactoryBoostModalOpen,
    setIsGoodsBoostModalOpen,
  } = useModal();
  const { t } = useTranslation();
  const openPlantsBoost = (): void => {
    if (kind === 'resource') {
      setIsQuarryBoostModalOpen(true);

      return;
    }

    if (kind === 'material') {
      setIsFactoryBoostModalOpen(true);

      return;
    }

    if (kind === 'goods') {
      setIsGoodsBoostModalOpen(true);
    }
  };

  return (
    <button
      className="flex rounded-[80px] gap-2 bg-white/10 backdrop-blur-3xl items-center pr-2 pl-3 py-1 shrink-0"
      type="button"
      onClick={openPlantsBoost}
    >
      <StringXSmall weight="bold" className="!text-accent">
        {t('Active boosts')}
      </StringXSmall>
      <BoostScaleIcon className="shrink-0 w-10 h-6" />
    </button>
  );
};

export { OpenPlantsBoost };
